import Util from '../utils/util'

const sources = [
    { name: 'baidu', includes: 'm.baidu.com/', queryParam: 'word' },
    { name: 'sougou', includes: '.sogou.com/web', queryParam: 'keyword' },
    { name: 'shenma', includes: 'so.m.sm.cn/s', queryParam: 'q' },
    { name: '360', includes: 'm.so.com/', queryParam: 'q' },
    { name: 'toutiao', includes: 'so.toutiao.com/search', queryParam: 'keyword' },
]

let decodeReferer = document.referrer
let queryObj = {}

try {
    decodeReferer = decodeURIComponent(decodeReferer)
    const query = decodeReferer.substring(decodeReferer.indexOf('?') + 1 ) // 取”?“后

    const queryString = Util.queryString
    queryObj = queryString(query)
} catch (error) {
    console.log('解析url错误',error)
}

const reportSearchWord = (articleId) => {
    let clkParamString
    for (const source of sources) {
        if (decodeReferer.includes(source.includes) && queryObj[source.queryParam]) {
            const keyword = queryObj[source.queryParam];
            const clkParam = `keyword:${keyword};from:${source.name}`
            clkParamString = encodeURIComponent(clkParam)
            window.sohuSpm.sendAction({
                acode: '10630',
                clkParam: `articleId:${articleId};${clkParam}`
            });
            break;
        }
    }
    return clkParamString
}

export default reportSearchWord
